'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { Map as ImmutableMap } from 'immutable';
import { map } from 'rxjs/operators/map';
import { ContentTypes } from '../constants/base';
import Stylesheets from '../models/Stylesheets';
const PAGES_BASE_PATH = 'cospages/v2';
const URL = ImmutableMap({
  [ContentTypes.BLOG_POST]: 'blogs/v3/blog-posts',
  [ContentTypes.LANDING_PAGE]: `${PAGES_BASE_PATH}/landing-pages`,
  [ContentTypes.SITE_PAGE]: `${PAGES_BASE_PATH}/site-pages`
});
const generateUrl = (contentType, id) => `${URL.get(contentType)}/${id}/stylesheet-trace`;
export default {
  fetchStylesheets(contentType, id) {
    return http.get(generateUrl(contentType, id)).pipe(map(Stylesheets.fromJS));
  }
};